import { Brain, Layers } from "lucide-react";
import { motion } from "framer-motion";

interface ThinkingVisualProps {
  isThinking: boolean;
  relevanceScore?: number;
}

const ThinkingVisual = ({ isThinking, relevanceScore }: ThinkingVisualProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex flex-col items-center justify-center space-y-6 p-6"
    >
      <motion.div
        animate={{
          scale: isThinking ? [1, 1.2, 1] : 1,
          rotate: isThinking ? [0, 15, -15, 0] : 0,
        }}
        transition={{
          duration: 2.5,
          repeat: isThinking ? Infinity : 0,
          ease: "easeInOut",
        }}
        className="relative"
      >
        <Brain className="w-24 h-24 text-purple-400" />
        {isThinking && (
          <>
            <motion.div
              className="absolute -inset-4 rounded-full"
              animate={{
                scale: [1, 1.3, 1],
                opacity: [0.6, 0.2, 0.6],
              }}
              transition={{
                duration: 2.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              style={{
                background: "radial-gradient(circle, rgba(167,139,250,0.4) 0%, rgba(167,139,250,0) 70%)",
              }}
            />
            <motion.div
              className="absolute -inset-8 rounded-full"
              animate={{
                scale: [1.2, 1, 1.2],
                opacity: [0.3, 0.1, 0.3],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              style={{
                background: "radial-gradient(circle, rgba(167,139,250,0.3) 0%, rgba(167,139,250,0) 80%)",
              }}
            />
          </>
        )}
      </motion.div>
      
      {relevanceScore !== undefined && (
        <div className="flex items-center space-x-3">
          <Layers className="w-6 h-6 text-purple-400" />
          <div className="text-base text-white/80">
            Relevance: {Math.round(relevanceScore * 100)}%
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default ThinkingVisual;